import { Component } from '@angular/core';
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { Proof } from '../../../../models/Proof';
import { Paginator } from '../../../../models/Paginator';
import { Filter } from '../../../../models/GenericCRUD/Filter';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { GenericCrudComponent } from '../../../../shared/components/generic-crud/generic-crud.component';
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-proof-home',
  standalone: true,
  imports: [GenericCrudComponent],
  templateUrl: './proof-home.component.html',
  styleUrl: './proof-home.component.css'
})
export class ProofHomeComponent {
  tableColumns: GenericTableColumn[] = [
    { name: 'Nombre', active: true, type: 'proof-name', key: 'generated_name', sort: false },
    { name: 'Exámenes', active: true, type: 'text', key: 'proof_definitions_names', sort: false },
    { name: 'Centro de Examen', active: true, type: 'text', key: 'proof_center.name', sort: true },
    { name: 'Sucursal', active: true, type: 'text', key: 'office.name', sort: false },
    { name: 'Límite Inscripción', active: true, type: 'date', key: 'registration_deadline', sort: true, format: 'dd/MM/yyyy' },
    { name: 'Fecha', active: true, type: 'date-time', key: 'date_time', sort: true, format: 'dd/MM/yyyy' },
    { name: 'Alumnos', active: true, type: 'text', key: 'n_students', sort: false },
  ];

  formFields: GenericFormField[] = [
    { name: 'proof_definitions', type: 'select', label: 'Exámenes', validations: 'required', url: '/config/proof-definition/listAll', singleSelection: false },
    { name: 'proof_center_id', type: 'select', label: 'Centro de Examen', validations: 'nullable', url: '/config/proof-center/listAll', singleSelection: true },
    { name: 'office_id', type: 'select', label: 'Sucursal', validations: 'nullable', url: '/config/office/listAll', singleSelection: true },
    { name: 'registration_deadline', type: 'date', label: 'Fecha Limite Inscripcion', validations: 'required' },
    { name: 'date', type: 'date', label: 'Fecha', validations: 'required', singleSelection: true },
    { name: 'time', type: 'time', label: 'Hora', validations: 'nullable', singleSelection: true },
  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'proof_definitions', type: 'select', label: 'Exámenes', validations: 'required', url: '/config/proof-definition/listAll', singleSelection: false },
    { name: 'proof_center_id', type: 'select', label: 'Centro de Examen', validations: 'nullable', url: '/config/proof-center/listAll', singleSelection: true },
    { name: 'office_id', type: 'select', label: 'Sucursal', validations: 'nullable', url: '/config/office/listAll', singleSelection: true },
    { name: 'registration_deadline', type: 'date', label: 'Fecha Limite Inscripcion', validations: 'required' },
    { name: 'date', type: 'date', label: 'Fecha', validations: 'required', singleSelection: true },
    { name: 'time', type: 'time', label: 'Hora', validations: 'nullable', singleSelection: true },
  ];

  proofFormFields: GenericFormField[] = [
    { name: 'user_id', type: 'select', label: 'Alumno', validations: 'required', url: '/user/students', singleSelection: true },
    { name: 'appointment_date_time_site', type: 'dateTime', label: 'Fecha y Hora de Cita', validations: 'nullable' },
    { name: 'qualification_id', type: 'select', label: 'Calificación', validations: 'nullable', url: '/config/qualification/list', singleSelection: true },
    { name: 'examiner_id', type: 'select', label: 'Examinador', validations: 'nullable', url: '/config/examiner/listAll', singleSelection: true, showIf: (proof) => this.showExaminerField(proof) }
  ];

  form: GenericForm = {
    successTitle: 'Convocatoria de examen creada correctamente',
    errorTitle: 'Error al crear la convocatoria de examen',
    method: 'POST',
    fields: this.formFields,
    name: 'convocatoria',
    createButtonTitle: 'Nueva convocatoria',
    cols: 2,
    createApiSlug: '/proof/store',
    formTitle: 'Crear Convocatoria de Examen',
    formButtonTitle: 'Crear',
    width: '3xl'
  };

  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      form: {
        method: 'PUT',
        successTitle: 'Convocatoria actualizada correctamente',
        errorTitle: 'Error al actualizar la convocatoria',
        fields: this.formFieldsEdit,
        name: 'convocatoria',
        createButtonTitle: '',
        cols: 2,
        createApiSlug: '',
        originalUpdateApiSlug: '/proof/update/{{id}}',
        updateApiSlug: '',
        originalFormTitle: 'Editar convocatoria',
        formTitle: '',
        formButtonTitle: 'Actualizar',
        width: '3xl'
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 7h-1a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-1"/><path d="M20.385 6.585a2.1 2.1 0 0 0-2.97-2.97l-8.415 8.385v3h3l8.385-8.415z"/><path d="M16 5l3 3"/></svg>`,
      confirmation: false
    },
    {
      name: 'Asignar Alumnos',
      key: 'assign-students',
      method: 'POST',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="7" r="4"/><path d="M17 21v-6"/><path d="M14 18h6"/><path d="M5 21v-2a4 4 0 0 1 4-4h0a4 4 0 0 1 4 4v2"/></svg>`,
      confirmation: true,
      questionText: '¿Desea asignar alumnos a la prueba?',
      actionSlug: '/proof/assign-students/{{id}}',
      form: {
        successTitle: 'Alumno asignado correctamente',
        errorTitle: 'Error al asignar alumno',
        method: 'POST',
        fields: this.proofFormFields,
        name: 'asignación',
        createButtonTitle: 'Nuevo Alumno',
        cols: 2,
        createApiSlug: '/proofs-users/store/{{id}}',
        formTitle: 'Asignar Alumno',
        formButtonTitle: 'Guardar',
        width: '2xl'
      }
    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12"/><path d="M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"/></svg>`,
      confirmation: true,
      questionText: '¿Desea eliminar la prueba?',
      deleteRowOnResponse: true,
      actionSlug: '/proof/delete/{{id}}',
    },


  ];

  table: GenericTable<Paginator<Proof>> = {
    columns: this.tableColumns,
    items: [],
    type: 'proof',
    loadItemsSlug: '/proof/index',
    loadTheoricalProofsSlug: '/proof/index-theorics',
    loadOpenProofsSlug: '/proof/index-open',
    loadClosedProofsSlug: '/proof/index-closed',
    paginate: true,
    name: 'pruebas',
    actions: this.tableActions,
    details: true,
  };

  filters: Filter[] = [
    { type: 'search', key: 'name|proof_type_name', operator: 'like', placeholder: 'Nombre' },
    { type: 'date-between', key: 'date', operator: 'between', parsed: "date-arr", placeholder: 'Fecha' }
  ];

  genericCRUD: GenericCRUD<Paginator<Proof>> = {
    genericForm: this.form,
    genericTable: this.table,
    genericFilters: this.filters,
    useModalForm: false
  };
  showExaminerField(proof: Proof): boolean {
    return proof?.proof_type?.type === 'Abierto' || proof?.proof_type?.type === 'Cerrado';
  }
}
